import { ChildDetailedForParentDto } from 'types';
import { jsonObjectsTexts } from 'consts/text';
import { EMPTY_VALUE_LABEL } from 'consts/labels/common';
import { parseChildSettlementDetailsIntoJsonObject } from 'utils/parsers/jsonObject/child/parseChildSettlementDetailsIntoJsonObject';
import { parseChildDietIntoJsonObject } from 'utils/parsers/jsonObject/child/parseChildDietIntoJsonObject';
import { parseChildForParentDtoIntoJsonObject } from 'utils/parsers/jsonObject/child/parseChildForParentDtoIntoJsonObject';

export const parseChildDetailedForParentDtoIntoJsonObject: (
    childDetailedForParentDto: ChildDetailedForParentDto,
) => object = (childDetailedForParentDto) => {
    const { child, settlementDetails, diet } = childDetailedForParentDto;

    const parsedChildJsonObject = parseChildForParentDtoIntoJsonObject(child);
    const parsedChildSettlementDetailsJsonObject = settlementDetails
        ? parseChildSettlementDetailsIntoJsonObject(settlementDetails)
        : EMPTY_VALUE_LABEL;
    const parsedChildDietJsonObject = diet ? parseChildDietIntoJsonObject(diet) : EMPTY_VALUE_LABEL;

    return {
        [jsonObjectsTexts.childDetailed.fields.child]: parsedChildJsonObject,
        [jsonObjectsTexts.childDetailed.fields.diet]: parsedChildDietJsonObject,
        [jsonObjectsTexts.childDetailed.fields.settlementDetails]:
            parsedChildSettlementDetailsJsonObject,
    };
};
